// CUSTOM: personalised-id-utils.js
// ID normalisation and comparison utilities for Shopify and Recharge IDs.
//
// Internal type standard:
//   Shopify IDs (variantId, productId, collectionId): store as NUMBER internally,
//     convert to STRING only at API/DOM boundaries.
//   Recharge IDs (bundleSelectionId, purchaseItemId): always store and use as STRING.

(function() {
  window.personalised = window.personalised || {};
  window.personalised.utils = window.personalised.utils || {};

  /**
   * Normalizes a Shopify ID to its standard internal format (number)
   * @param {string|number} id - The ID to normalize
   * @returns {number|null} The normalized ID as a number, or null if invalid
   */
  function normalizeShopifyId(id) {
    if (id === null || id === undefined) return null;
    const numId = Number(id);
    return !isNaN(numId) ? numId : null;
  }

  /**
   * Safely compares two Shopify IDs for equality
   * @param {string|number} id1 - First ID to compare
   * @param {string|number} id2 - Second ID to compare
   * @returns {boolean} True if IDs are equal, false otherwise
   */
  function shopifyIdsEqual(id1, id2) {
    const num1 = normalizeShopifyId(id1);
    const num2 = normalizeShopifyId(id2);
    return num1 !== null && num2 !== null && num1 === num2;
  }

  /**
   * Normalizes a Recharge ID to its standard internal format (string)
   * @param {string|number} id - The ID to normalize 
   * @returns {string|null} The normalized ID as a string, or null if invalid
   */
  function normalizeRechargeId(id) {
    if (id === null || id === undefined) return null;
    return String(id);
  }

  /**
   * Safely compares two Recharge IDs for equality
   * @param {string|number} id1 - First ID to compare
   * @param {string|number} id2 - Second ID to compare
   * @returns {boolean} True if IDs are equal, false otherwise
   */
  function rechargeIdsEqual(id1, id2) {
    const str1 = normalizeRechargeId(id1);
    const str2 = normalizeRechargeId(id2);
    return str1 !== null && str2 !== null && str1 === str2;
  }

  /**
   * Formats a Shopify ID for external API use (as string)
   * @param {string|number} id - The ID to format for API use
   * @returns {string|null} The ID formatted as a string, or null if invalid
   */
  function formatShopifyIdForApi(id) {
    const numId = normalizeShopifyId(id);
    return numId !== null ? String(numId) : null;
  }

  Object.assign(window.personalised.utils, {
    normalizeShopifyId,
    shopifyIdsEqual,
    normalizeRechargeId,
    rechargeIdsEqual,
    formatShopifyIdForApi
  });
})();
